// Estate and asset preservation: the fifth goal-sheet area.
//
// The old packet spent twenty generic pages here; this report had been spending
// none. Both were wrong ways to hold the same truth: this is the part of the
// meeting where the full service gets positioned, and it deserves this
// household's facts rather than a glossary.
//
// The three states do the talking. "In place" is a fact from the questionnaire;
// "you told us there isn't one" is the advisor having asked; "not yet
// discussed" is an agenda item, and the section never dresses one state up as
// another.

const STATUS = {
  'in-place': { label: 'In place', cls: 'is-inplace' },
  none: { label: 'Not in place', cls: 'is-none' },
  unknown: { label: 'Not yet discussed', cls: 'is-unknown' },
};

function Row({ item }) {
  const s = STATUS[item.status];
  return (
    <div className="asmt-prot-row">
      <span className={`asmt-prot-badge ${s.cls}`}>{s.label}</span>
      <div>
        <div className="asmt-prot-label">{item.label}</div>
        {/* The why prints only when it is a live question: something in place
            needs no argument for its own existence. */}
        {item.status !== 'in-place' && <p className="asmt-prot-why">{item.why}</p>}
      </div>
    </div>
  );
}

export default function ProtectionSection({ checklist }) {
  if (!checklist) return null;
  const { docs, coverage, yearsEstablished, counts, anythingKnown } = checklist;

  return (
    <section className="asmt-card" id="protection">
      <div className="asmt-card-head">
        <h2>What protects all of the above</h2>
        {anythingKnown && (
          <span className="asmt-card-note">
            {counts.inPlace} in place · {counts.none} missing · {counts.unknown} to discuss
          </span>
        )}
      </div>
      <p className="asmt-lede">
        {anythingKnown
          ? 'Everything earlier in this report is what you have. This is what stands '
            + 'between it and the things that go wrong: courts, lawsuits, a long illness, '
            + 'a death out of order.'
          : 'We have not covered this ground together yet. These are the questions the '
            + 'second half of the conversation is for, because everything earlier in this '
            + 'report depends on the answers.'}
      </p>

      <div className="asmt-prot-cols">
        <div>
          <h3 className="asmt-subhead">Estate documents</h3>
          {yearsEstablished && (
            <p className="asmt-note" style={{ marginBottom: 10 }}>
              Last established or updated: {yearsEstablished}.
            </p>
          )}
          <div className="asmt-prot-list">
            {docs.map(d => <Row item={d} key={d.key} />)}
          </div>
        </div>
        <div>
          <h3 className="asmt-subhead">Coverage</h3>
          <div className="asmt-prot-list">
            {coverage.map(c => <Row item={c} key={c.key} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
